import { DEFAULT_INPUT_HEIGHT, DEFAULT_PADDING_BOTTOM, DEFAULT_MIN_EXPANDED_HEIGHT, } from '../constants/dualModeConstants';
import { defaultDualModeCardConfig, defaultTopSectionConfig, } from '../product/aiSearchConfig';
/**
 * Resolves dual search enabled state from portal config
 * Priority: portal > false (hardcoded fallback)
 * NOTE: Unified in Portal. No override from ClientAi or Designer.
 */
export function resolveDualSearchEnabled(portalConfig) {
    if (portalConfig?.clientAIUseDualSearch !== undefined) {
        return portalConfig.clientAIUseDualSearch;
    }
    return false; // Fallback hardcoded
}
/**
 * Resolves dual mode card configuration with priority
 * Priority: Designer props > Portal > Defaults
 * NOTE: NO ClientAi embedConfig - only Portal and Designer props
 */
export function resolveDualModeCardConfig(portalConfig, 
// embedConfig removed - not needed, Portal has all general configs
designerProps) {
    const defaults = defaultDualModeCardConfig;
    const portal = { ...defaults, ...portalConfig };
    // No ClientAi layer - Portal has all general configs
    // Map semantic designer props to config structure
    const designerOverrides = {};
    if (designerProps?.cardMaxHeight !== undefined) {
        designerOverrides.maxHeight = designerProps.cardMaxHeight;
    }
    if (designerProps?.cardShowDescription !== undefined) {
        designerOverrides.showDescription = designerProps.cardShowDescription;
    }
    if (designerProps?.cardShowPrice !== undefined) {
        designerOverrides.showPrice = designerProps.cardShowPrice;
    }
    if (designerProps?.cardShowAddToCart !== undefined) {
        designerOverrides.showAddToCartButton = designerProps.cardShowAddToCart;
    }
    if (designerProps?.cardPriceBelowTitle !== undefined) {
        designerOverrides.priceBelowTitle = designerProps.cardPriceBelowTitle;
    }
    if (designerProps?.cardOrientation !== undefined) {
        designerOverrides.orientation = designerProps.cardOrientation;
    }
    const designer = { ...portal, ...designerOverrides };
    const applyPriceBelowTitle = (order) => {
        if (!Array.isArray(order) || order.length === 0) {
            return order;
        }
        const normalized = order.filter((value, index) => order.indexOf(value) === index);
        if (!normalized.includes('productName')) {
            return normalized;
        }
        const withoutPricing = normalized.filter((value) => value !== 'pricing');
        const titleIndex = withoutPricing.indexOf('productName');
        const next = [...withoutPricing];
        next.splice(titleIndex + 1, 0, 'pricing');
        return next;
    };
    const finalElementOrder = designer.priceBelowTitle
        ? applyPriceBelowTitle(designer.elementOrder)
        : designer.elementOrder;
    // Convert to ProductFormatting format
    return {
        maxHeight: designer.maxHeight,
        showTitle: designer.showTitle ?? true,
        showDescription: designer.showDescription,
        showPrice: designer.showPrice,
        showAddToCartButton: designer.showAddToCartButton,
        showVariantSelection: designer.showVariantSelection,
        elementOrder: finalElementOrder,
        orientation: designer.orientation,
        // Additional defaults for ProductFormatting
        addToCart: false,
        clickBehavior: 'callback',
        cursorStyle: 'pointer',
        cardInteractive: true,
    };
}
/**
 * Resolves top section configuration with priority
 * Priority: Designer props > Portal > Defaults
 * NOTE: NO ClientAi embedConfig - only Portal and Designer props
 */
export function resolveTopSectionConfig(portalConfig, 
// embedConfig removed - not needed, Portal has all general configs
designerProps) {
    const defaults = defaultTopSectionConfig;
    const portal = { ...defaults, ...portalConfig };
    // No ClientAi layer - Portal has all general configs
    // Map semantic designer props
    const designerOverrides = {};
    if (designerProps?.topSectionMaxHeight !== undefined) {
        designerOverrides.maxHeight = designerProps.topSectionMaxHeight;
    }
    if (designerProps?.topSectionSeeMoreLabel !== undefined) {
        designerOverrides.seeMoreLabel = designerProps.topSectionSeeMoreLabel;
    }
    if (designerProps?.topSectionSeeLessLabel !== undefined) {
        designerOverrides.seeLessLabel = designerProps.topSectionSeeLessLabel;
    }
    const designer = { ...portal, ...designerOverrides };
    return designer;
}
/**
 * Resolves layout configuration with priority
 * Priority: Designer props > Portal > Defaults
 * NOTE: NO ClientAi embedConfig - only Portal and Designer props
 * ClientAi only provides initialHeight override via embed.template.js
 * inputHeight, paddingBottom, minExpandedHeight are hardcoded - not configurable
 */
export function resolveLayoutConfig(portalConfig, 
// embedConfig removed - not needed, Portal has all general configs
designerProps) {
    const defaults = {
        initialHeight: 500,
        inputHeight: DEFAULT_INPUT_HEIGHT, // Hardcoded - not configurable
        paddingBottom: DEFAULT_PADDING_BOTTOM, // Hardcoded - not configurable
        minExpandedHeight: DEFAULT_MIN_EXPANDED_HEIGHT, // Hardcoded - not configurable
        headerHeightValue: '88px',
        headerCssVariable: '--header-height',
        useCssVariable: true,
    };
    const portal = { ...defaults, ...portalConfig };
    // No ClientAi layer - Portal has all general configs
    // No designer overrides for inputHeight, paddingBottom, minExpandedHeight - they're hardcoded
    return portal;
}
//# sourceMappingURL=dualModeConfig.js.map